import { get, post, type RequestConfig } from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { DonationDetailRecord } from "@project/types/donation-detail";
import type { AddDonationPayload } from "@project/types/donation-donor";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/donation-details`;
const SILENT: RequestConfig = { showNotification: false };

class DonationDetailService {
  listDonationDetailsPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<DonationDetailRecord>> => {
    return fetchListPage<DonationDetailRecord>(`${BASE}/`, query);
  };

  getDonationDetail = async (
    id: number
  ): Promise<DonationDetailRecord | undefined> => {
    const data = await get<
      ApiItemResponse<DonationDetailRecord> | DonationDetailRecord
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  addDonation = async (payload: AddDonationPayload): Promise<unknown> => {
    return post(`${JIVANDHARA_BASE}/donations/add/`, payload, SILENT);
  };
}

export const donationDetailService = new DonationDetailService();
